import styled from "styled-components/macro";
import {device} from "../../styles";

export const Root = styled.div`

    width: 500px;
    padding: 15px 50px 15px 20px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.7);
    transition: background-color 0.3s;
    position: relative;
    
    ${device.less768} {
        width: auto;
    }

    &:hover {
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.8);
    }
`;

export const Title = styled.div`
    font-family: LatoWebSemibold, sans-serif;
    color: #fff;
    line-height: 20px;
    font-size: 17px;
    margin-bottom: 10px;
    
    ${device.less768} {
        font-size: 16px;
    }
`;

export const Message = styled.div`
    color: #fff;
    line-height: 20px;
    font-size: 16px;
    font-family: LatoWeb, sans-serif;
    opacity: 0.7;

    & + & {
        margin-top: 6px;
    }

    ${device.less768} {
        font-size: 14px;
    }
`;

export const Button = styled.button`
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    position: absolute;
    top: 15px;
    right: 20px;
    width: 18px;
    height: 18px;

    &:before,
    &:after {
        content: '';
        position: absolute;
        top: (18px - 2px) / 2;
        left: 0;
        right: 0;
        height: 2px;
        background: #fff;
        border-radius: 2px;
    }

    &:before {
        transform: rotate(45deg);
    }

    &:after {
        transform: rotate(-45deg);
    }

    span {
        display: block;
    }

`;
